import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})

export default class GrossingTouchMediaCard extends Vue {
    @Prop(Object) readonly mediaInfo!: object
}
